// ======================================================================
// 📁 File: src/modules/ppe/components/process/ProcessKpiBar.jsx
// 📝 Purpose:
//   KPI Bar for Process Master
//   - Total processes
//   - Active processes
//   - Inactive processes
//   - Average run time (minutes)
// ======================================================================

import React from "react";

// ----------------------------------------------------------------------
// KPI Card (local, lightweight – SAME STYLE AS BoughtOutKpiBar)
// ----------------------------------------------------------------------
const KpiCard = ({ title, value, color }) => (
  <div
    style={{
      flex: 1,
      background: "#fff",
      borderRadius: 12,
      padding: "12px 16px",
      boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
      borderLeft: `6px solid ${color}`,
    }}
  >
    <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>
      {title}
    </div>
    <div style={{ fontSize: 22, fontWeight: 600 }}>
      {value}
    </div>
  </div>
);

// ----------------------------------------------------------------------
// Process KPI Bar
// ----------------------------------------------------------------------
export default function ProcessKpiBar({ rows = [] }) {
  const total = rows.length;

  const active = rows.filter((r) => r.is_active === true).length;
  const inactive = rows.filter((r) => r.is_active === false).length;

  const runTimes = rows
    .map((r) => Number(r.run_time_minutes))
    .filter((v) => !isNaN(v) && v > 0);

  const avgRunTime =
    runTimes.length > 0
      ? Math.round(runTimes.reduce((a, b) => a + b, 0) / runTimes.length)
      : 0;

  return (
    <div
      style={{
        display: "flex",
        gap: 16,
        marginBottom: 20,
      }}
    >
      <KpiCard
        title="Total Processes"
        value={total}
        color="#0f766e"
      />
      <KpiCard
        title="Active Processes"
        value={active}
        color="#16a34a"
      />
      <KpiCard
        title="Inactive Processes"
        value={inactive}
        color="#dc2626"
      />
      <KpiCard
        title="Avg Run Time (mins)"
        value={avgRunTime}
        color="#2563eb"
      />
    </div>
  );
}
